export const rootElementId = 'crossDeviceLoginDisplayCodeModal-container';

export const translation = {
  common: [],
  feature: 'Authentication.CrossDevice'
};
